import { render, staticRenderFns } from "./NoResourceFoundMessage.vue?vue&type=template&id=54255470&scoped=true"
import script from "./NoResourceFoundMessage.vue?vue&type=script&lang=js"
export * from "./NoResourceFoundMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54255470",
  null
  
)

export default component.exports